import type { Permission } from '../../core/models/permission.model';

export interface NavItem {
  key: string;
  label: string;
  icon: string;
  route: string;
  // Sin permission => visible con solo sesión activa (dashboard, configuración, plan).
  // 'settings' queda sin permiso propio a propósito: CLAUDE.md §3 dice que sus sub-rutas
  // mezclan manage_bot/isAccountOwner por sección — no hay un único código que aplique al
  // ítem de nav completo (confirmar por sub-ruta al construir la feature).
  permission?: Permission;
}

// Mismo set y orden que NAV_ITEMS en _nav.js — fuente única para Sidebar y BottomNav
// (que hoy toma `NAV_ITEMS.slice(0, 5)` a mano).
export const NAV_ITEMS: NavItem[] = [
  { key: 'dashboard', label: 'Inicio', icon: 'dashboard', route: '/dashboard' },
  { key: 'mensajes', label: 'Mensajes', icon: 'chat', route: '/messages', permission: 'view_messages' },
  { key: 'pedidos', label: 'Pedidos', icon: 'shopping_cart', route: '/orders', permission: 'view_orders' },
  // Ver catálogo no pide permiso (solo tenantContext) — solo crear/editar/eliminar/toggle
  // pide edit_catalog (contrato de features/catalog/, corrige el mapeo original de parte_10
  // §3 que ataba toda la página a edit_catalog). Mismo criterio que dashboard: se gatea la
  // acción, no la página completa.
  { key: 'catalogo', label: 'Catálogo', icon: 'inventory_2', route: '/catalog' },
  { key: 'reportes', label: 'Reportes', icon: 'bar_chart', route: '/reports', permission: 'view_reports' },
  { key: 'config', label: 'Configuración', icon: 'settings', route: '/settings' },
  { key: 'plan', label: 'Mi Plan', icon: 'workspace_premium', route: '/plan' },
];
